import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';
import { BehaviorSubject, concat, of, type OperatorFunction, shareReplay, switchMap } from 'rxjs';
import type { FilterDataResult } from './filter-data-result';
import { ToResult } from '@team23/ts-result';
import { FilterDataStatus } from './filter-data-status';
import type { FilterModel } from './filter';
import type { FilterConfig } from './filter-config';

export const FilterConfigToken = new InjectionToken<Array<FilterConfigService>>('filter-config');

// TODO: better separation of search and select filter
export abstract class FilterConfigService<Key extends string = string, Service = unknown> {
    public readonly type: FilterConfig['type'];
    public readonly placeholder: string = '';
    public readonly options$: Observable<FilterDataResult>;
    public readonly reload$ = new BehaviorSubject<void>(undefined);

    protected constructor(
        public filterModel: FilterModel<Key>,
        protected _api: Service,
    ) {
        this.options$ = this.reload$.pipe(this._loadData(this._getOptions$()));
        this.type = filterModel.type;
    }

    protected _loadData(data$: Observable<FilterDataResult>): OperatorFunction<void, FilterDataResult> {
        return (subject: Observable<void>) => subject.pipe(
            switchMap(() =>
                concat(
                    of(ToResult.fromErrorKey(FilterDataStatus.Loading)),
                    data$,
                ),
            ),
            shareReplay(1),
        );
    }

    protected abstract _getOptions$(): Observable<FilterDataResult>;
}
